/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { isNaNDependencies } from './dependenciesIsNaN.generated';
import { isNumericDependencies } from './dependenciesIsNumeric.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMode } from '../../factoriesAny.js';
export var modeDependencies = {
  isNaNDependencies: isNaNDependencies,
  isNumericDependencies: isNumericDependencies,
  typedDependencies: typedDependencies,
  createMode: createMode
};